import { render, staticRenderFns } from "./App.vue?vue&type=template&id=cf9fab84&scoped=true&lang=pug&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.styl?vue&type=style&index=0&id=cf9fab84&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9fab84",
  null
  
)

export default component.exports